/* eslint-disable complexity */

// Recorremos las columnas y le asignamos un ancho por defecto en caso
// que no tengamos esa información
function setTableWidths(routeName, columns) {
    const localStorageWidthsData = JSON.parse(localStorage.getItem(`table_width_${routeName}`));

    const widths = {};
    columns.forEach(item => {
        const { field } = item;
        let defaultWidthField;

        const datetime_fields = [
            'aml_checked_on',
            'blocking_date',
            'closing_date',
            'created_on',
            'expires_on',
            'first_subscription_date',
            'opening_date',
            'registration_date',
            'request_date',
            'resolved_on',
            'updated_on'
        ];
        const date_fields = [
            'birth_date',
            'birthdate',
            'date_of_asset_value',
            'deathdate',
            'decease_date',
            'document_expiration_date',
            'first_payment_date',
            'lei_expiration_date',
            'nav_date',
            'operation_date',
            'pp_redemption_entitlement_date'
        ];
        const currency_fields = ['net_amount', 'gross_amount', 'nav'];
        const number_fields = ['intervener_issues_count', 'operation_issues_count'];

        switch (field) {
            case 'description':
                defaultWidthField = 550;
                break;
            case 'name':
            case 'telephone':
            case 'birthdate':
                defaultWidthField = 170;
                break;
            case 'id_object':
                defaultWidthField = 160;
                break;
            case 'lastname_1':
            case 'lastname_2':
                defaultWidthField = 220;
                break;
            case 'photo':
                defaultWidthField = 120;
                break;
            case 'key_operation_type':
            case 'key_sub_operation_type':
            case 'operation_type':
            case 'key_product':
            case 'name_product':
                defaultWidthField = 180;
                break;
            case 'operation_status':
                defaultWidthField = 110;
                break;
            case 'alias':
            case 'alias_account':
            case 'email':
                defaultWidthField = 250;
                break;
            case 'interveners':
                defaultWidthField = 400;
                break;
            default:
                if (date_fields.includes(field)) {
                    defaultWidthField = 130;
                } else if (datetime_fields.includes(field)) {
                    defaultWidthField = 170;
                } else if (currency_fields.includes(field)) {
                    defaultWidthField = 130;
                } else if (number_fields.includes(field)) {
                    defaultWidthField = 100;
                } else {
                    defaultWidthField = 150;
                }
        }
        const width = (localStorageWidthsData && localStorageWidthsData[field]) || defaultWidthField;
        widths[field] = width > 0 ? width : defaultWidthField;
    });
    return widths;
}

export { setTableWidths };
